module.exports = __webpack_public_path__ + "img/branchtotreasary.fw.89dda133.png";